// extracted by mini-css-extract-plugin
export default {"NumberInput__label":"NumberInput_NumberInput__label__z1uQU","NumberInput":"NumberInput_NumberInput__53nCd"};